<template>
  <div :style="{ height: tableHeight }">
    <el-table
      :row-key="getRowKeys"
      class="scpc-task-table"
      :data="table_config.tableData"
      :header-cell-style="{
        background: '#f9f9f9',
        fontSize: '16px',
      }"
      :row-style="{ height: '38' }"
      @row-click="rowFun"
      @header-dragend="headerDragend"
      :row-class-name="tableRowClassName"
      lazy
      :load="loadChiTask"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      v-el-table-infinite-scroll="table_config.loadList"
      @selection-change="changeBox"
      border
      ref="table"
      style="width: 100%"
      height="100%"
    >
      <div slot="empty" class="empty" style="display: none;">
        暂无数据
      </div>
      <el-table-column v-if="checkbox" type="selection" />
      <template>
        <el-table-column
          v-for="(header, index) in table_config.thead"
          :key="index"
          :prop="header.prop"
          :min-width="header.width"
          :fixed="header.fixed"
        >
          <!-- 表头 -->
          <template v-slot:header>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span>{{header.label}}</span>
            </div>
          </template>
          <!-- 内容 @click.stop="handleCellClick(scope.row, header)"-->
          <template slot-scope="scope">
            <!-- taskName列，需要定制化 -->
            <div class="scope-content" v-if="header.prop === 'taskname'&& tab === 'todoTask'">
              <el-tooltip
                v-if="scope.row.taskType === '1'"
                effect="dark"
                :content="scope.row.nodeName + '-' + scope.row.taskname "
                placement="bottom"
                popper-class="texttooltip"
                :open-delay="500"
              >
                <span class="scope-content-text">
                  {{scope.row.nodeName}}  -  {{scope.row.taskname}}
                </span>
              </el-tooltip>
              <el-tooltip
                v-else
                effect="dark"
                :content="scope.row.taskname"
                placement="bottom"
                popper-class="texttooltip"
                :open-delay="500"
              >
                <span class="scope-content-text">
                  {{scope.row.taskname}}
                </span>
              </el-tooltip>
              <span class="scpc-operate-icon">
                <span
                  class="task_within"
                  v-if="scope.row.overdueFlag == 1"
                >逾</span>
                <span v-if="scope.row.collectFlag == '1'">
                  <i
                    class="iconfont icon-shoucang1"
                    v-show="scope.row.collectFlag == 1"
                    style="color: #ffb83e; margin-right: 12px"
                  />
                </span>
                <span style="padding: 0 6px" v-if="scope.row.milestone === '1'">
                  <i
                    class="iconfont icon-lichengbei-qizhi drawer_icon"
                    v-if="scope.row.milestone == '1'"
                    style="color: #2878ff"
                  />
                </span>
                <i
                  class="iconfont icon-liuchengrenwu liuchen_icon"
                  v-if="scope.row.taskType === '1'"
                  @click.stop="config.figureFun(scope.row)"
                  style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                />
              </span>
            </div>
            <div class="scope-content" v-else-if="header.prop === 'taskname'&& tab !== 'todoTask'">
              <el-tooltip
                effect="dark"
                :content="scope.row.taskname"
                placement="bottom"
                popper-class="texttooltip"
                :open-delay="500"
              >
                <span class="scope-content-text">
                  {{scope.row.taskname}}
                </span>
              </el-tooltip>
              <span class="scpc-operate-icon">
                <span
                  class="task_within"
                  v-if="scope.row.overdueFlag == 1"
                >逾</span>
                <span v-if="scope.row.collectFlag == '1'">
                  <i
                    class="iconfont icon-shoucang1"
                    v-show="scope.row.collectFlag == 1"
                    style="color: #ffb83e; margin-right: 12px"
                  />
                </span>
                <span style="padding: 0 6px" v-if="scope.row.milestone === '1'">
                  <i
                    class="iconfont icon-lichengbei-qizhi drawer_icon"
                    v-if="scope.row.milestone == '1'"
                    style="color: #2878ff"
                  />
                </span>
                <i
                  class="iconfont icon-liuchengrenwu liuchen_icon"
                  v-if="scope.row.taskType === '1'"
                  @click.stop="config.figureFun(scope.row)"
                  style="
                    color: rgba(28, 106, 235, 1);
                    padding: 0 6px;
                    cursor: pointer;
                  "
                />
              </span>
            </div>
            <!-- 当前执行人 负责人 确认人 type = 11-->
            <div
              style="
                display: flex;
                overflow: hidden;
                align-items: center;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              v-else-if="header.type === '11'"
            >
              <!-- 系统字段 -->
              <div v-if="header.sysFlag === '1'" style="display: flex; align-items: center;">
                <div class="scpc-operate-photos">
                  <div style="display: flex; width: 6px">
                    <div
                      class="scope-content"
                      v-for="(item1, index) in scope.row[header.prop]"
                      :key="index"
                    >
                      <!-- 头像 -->
                      <div class="scpc-operate-photo">
                        <div v-if="item1.avatar && item1.avatar != ''&& item1.avatar != null">
                          <img :src="item1.avatar">
                        </div>
                        <div class="img" v-else>
                          {{item1.name.substring(0, 1)}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                  display: flex;
                  align-items: center;
                  min-width: 55px;
                "
                >
                  <div
                    style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-left: 8px;
                  "
                  >
                    <span
                      v-for="(item1, index) in scope.row[header.prop]"
                      :key="index"
                    >
                      <span class="scope-content-text">
                        <span v-show="channel === 'wechat'">
                          <ww-open-data type="userName" :openid="item1.name" />
                        </span>
                        <span v-show="channel !== 'wechat'">{{item1.name}}</span>
                        <span v-if="index<(scope.row[header.prop].length-1)" style="margin-right:5px">,</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <!-- 非系统字段 -->
              <div v-else-if="header.sysFlag !== '1' && scope.row.fieldValueObject" style="display: flex; align-items: center;">
                <div class="scpc-operate-photos">
                  <div style="display: flex; width: 6px">
                    <div
                      class="scope-content"
                      v-for="(item1, index) in scope.row.fieldValueObject[header.prop]"
                      :key="index"
                    >
                      <!-- 头像 -->
                      <div class="scpc-operate-photo">
                        <div v-if="item1.avatar && item1.avatar != ''&& item1.avatar != null">
                          <img :src="item1.avatar">
                        </div>
                        <div class="img" v-else>
                          {{item1.name.substring(0, 1)}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                  display: flex;
                  align-items: center;
                  min-width: 55px;
                "
                >
                  <div
                    style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-left: 8px;
                  "
                  >
                    <span
                      v-for="(item1, index) in scope.row.fieldValueObject[header.prop]"
                      :key="index"
                    >
                      <span class="scope-content-text">
                        <span v-show="channel === 'wechat'">
                          <ww-open-data type="userName" :openid="item1.name" />
                        </span>
                        <span v-show="channel !== 'wechat'">{{item1.name}}</span>
                        <span v-if="index<(scope.row.fieldValueObject[header.prop].length-1)" style="margin-right:5px">,</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 创建人 type = 10-->
            <div class="scope-content" v-else-if="header.type === '10'">
              <div v-if="header.sysFlag === '1'&& scope.row[header.prop]" style="display: flex; align-items: center;">
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row[header.prop] && scope.row[header.prop].avatar != '' && scope.row[header.prop].avatar !== null
                    "
                  >
                    <img class="img" :src="scope.row[header.prop].avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row[header.prop].name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row[header.prop].name" />
                </span>
                <span class="scope-content-text" v-if="channel === 'ding'">{{scope.row[header.prop].name}}</span>
              </div>
              <div v-if="header.sysFlag === '0'&& scope.row[header.prop]" style="display: flex; align-items: center;">
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row[header.prop] && scope.row[header.prop].avatar != '' && scope.row[header.prop].avatar !== null
                    "
                  >
                    <img class="img" :src="scope.row[header.prop].avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row[header.prop].name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row[header.prop].name" />
                </span>
                <span class="scope-content-text" v-if="channel === 'ding'">{{scope.row[header.prop].name}}</span>
              </div>
              <div v-else-if="header.sysFlag !== '1'&& scope.row.fieldValueObject&&scope.row.fieldValueObject[header.prop]" style="display: flex; align-items: center;">
                <div class="scpc-operate-photo" style="padding-right: 2px">
                  <div
                    v-if="
                      scope.row.fieldValueObject[header.prop] && scope.row.fieldValueObject[header.prop].avatar != '' && scope.row.fieldValueObject[header.prop].avatar !== null
                    "
                  >
                    <img class="img" :src="scope.row.fieldValueObject[header.prop].avatar">
                  </div>
                  <div
                    class="img"
                    v-else
                  >
                    {{scope.row.fieldValueObject[header.prop].name.substring(0, 1)}}
                  </div>
                </div>
                <span class="scope-content-text" v-if="channel === 'wechat'">
                  <ww-open-data type="userName" :openid="scope.row.fieldValueObject[header.prop].name" />
                </span>
                <span class="scope-content-text" v-if="channel === 'ding'">{{scope.row.fieldValueObject[header.prop].name}}</span>
              </div>
            </div>
            <!-- 任务状态 -->
            <div v-else-if="header.prop === 'status'">
              <div class="scope-content" v-if="scope.row.taskType === '1'">
                <span v-if="scope.row.status === '0'|| scope.row.status === '8'" class="tableTextColor tableTextColor1">未开始</span>
                <span v-if="scope.row.status === '1'" class="tableTextColor tableTextColor2">未完成</span>
                <span v-if="scope.row.status === '2'" class="tableTextColor tableTextColor6">已完成</span>
                <span v-if="scope.row.status === '3'" class="tableTextColor tableTextColor5">待确认</span>
                <span v-if="scope.row.status === '4'" class="tableTextColor tableTextColor7">已终止</span>
              </div>
              <!-- 标准 -->
              <div class="scope-content" v-else-if="scope.row.taskType === '0'">
                <span v-if="scope.row.status === '0'" class="tableTextColor tableTextColor1">未指派</span>
                <span v-if="scope.row.status === '1'" class="tableTextColor tableTextColor2">未完成</span>
                <span v-if="scope.row.status === '2'" class="tableTextColor tableTextColor6">已完成</span>
                <span v-if="scope.row.status === '3'" class="tableTextColor tableTextColor5">待确认</span>
                <span v-if="scope.row.status === '4'" class="tableTextColor tableTextColor7">已终止</span>
                <span v-if="scope.row.status === '8'" class="tableTextColor tableTextColor1">未开始</span>
              </div>
              <div class="scope-content" v-else-if="scope.row.proNumber">
                <span v-if="scope.row.status === '0'|| scope.row.status === '8'" class="tableTextColor tableTextColor1">未开始</span>
                <span v-if="scope.row.status === '1'" class="tableTextColor tableTextColor2">进行中</span>
                <span v-if="scope.row.status === '2'" class="tableTextColor tableTextColor6">已完成</span>
              </div>
              <!-- 敏捷 -->
              <div
                class="scope-content"
                v-else-if="scope.row.proTypeId === '2001'"
              >
                <span v-if="scope.row.status === '0'" class="tableTextColor tableTextColor1">需求池</span>
                <span v-if="scope.row.status === '1'" class="tableTextColor tableTextColor2">开发中</span>
                <span v-if="scope.row.status === '5'" class="tableTextColor tableTextColor3">待测试</span>
                <span v-if="scope.row.status === '3'" class="tableTextColor tableTextColor4">测试中</span>
                <span v-if="scope.row.status === '6'" class="tableTextColor tableTextColor5">待验收</span>
                <span v-if="scope.row.status === '2'" class="tableTextColor tableTextColor6">验收完成</span>
                <span v-if="scope.row.status === '4'" class="tableTextColor tableTextColor7">已终止</span>
              </div>
              <div class="scope-content" v-else-if="scope.row.proTypeId === '0'">
                <span v-if="scope.row.status === '0'" class="tableTextColor tableTextColor1">未指派</span>
                <span v-if="scope.row.status === '1'" class="tableTextColor tableTextColor2">未完成</span>
                <span v-if="scope.row.status === '2'" class="tableTextColor tableTextColor6">已完成</span>
                <span v-if="scope.row.status === '3'" class="tableTextColor tableTextColor5">待确认</span>
                <span v-if="scope.row.status === '4'" class="tableTextColor tableTextColor7">已终止</span>
              </div>
              <div class="scope-content" v-else-if="scope.row.proTypeId === '1'">
                <span v-if="scope.row.status === '0'" class="tableTextColor tableTextColor1">未开始</span>
                <span v-if="scope.row.status === '1'" class="tableTextColor tableTextColor2">未完成</span>
                <span v-if="scope.row.status === '2'" class="tableTextColortableTextColor6">已完成</span>
                <span v-if="scope.row.status === '3'" class="tableTextColor tableTextColor5">待确认</span>
              </div>
            </div>
            <!-- 进度条 -->
            <div class="scope-content" v-else-if="header.type === '16'">
              <!-- 滑块 -->
              <el-progress
                style="width: 300px"
                :stroke-width="12"
                :percentage="scope.row.progressRate"
                color="#2878ff"
              />
            </div>
            <!-- 标签 -->
            <div class="scope-content" v-else-if="header.type === '15'">
              <div class="info_box" v-for="(tag, index1) in scope.row[header.prop]" :key="index1">
                <el-tag
                  style="margin-right: 5px"
                  :style="
                    'color:' +
                      tag.color +
                      ';background:' +
                      convertHex(tag.color, 10)
                  "
                  type="warning"
                >{{tag.labelName}}</el-tag>
              </div>
            </div>
            <!-- type = 0 type = 1 type = 4 type = 5 @click.stop="cellClickModule(header, scope.row, scope.$index)"-->
            <div class="scope-content" v-else-if="header.type === '0' || header.type === '1'">
              <span class="scope-content-text" v-if="header.sysFlag == '1'">
                {{scope.row[header.prop]}}
                <span v-if="header.type === '1' && scope.row[header.prop] !== '' && scope.row[header.prop] !== null">{{header.unit}}</span>
              </span>
              <span class="scope-content-text" style="cursor: pointer;color: #2878ff;" v-if="header.sysFlag == '0' && header.clickData &&header.clickData.idMapping !== null" @click.stop="handleCellClick(scope.row, header)">
                {{scope.row[header.prop]}}
              </span>
              <span class="scope-content-text" v-if="header.sysFlag == '0' && !(header.clickData &&header.clickData.idMapping !== null)">
                {{scope.row[header.prop]}}
              </span>
              <span v-if="header.sysFlag !== '1'&& scope.row.fieldValueObject">
                <span class="scope-content-text">{{scope.row.fieldValueObject[header.prop]}}
                  <span v-if="header.type === '1' && scope.row.fieldValueObject[header.prop] !== '' && scope.row.fieldValueObject[header.prop] !== null">{{header.unit}}</span>
                </span>
              </span>
            </div>
            <div class="scope-content" v-else-if="header.type === '4'">
              <span class="scope-content-text" v-if="header.sysFlag == '1'">
                <span v-if="header.unit === '10' && scope.row[header.prop]">
                  {{(scope.row[header.prop]).substring(0, 10)}}
                </span>
                <span v-else>
                  {{scope.row[header.prop]}}
                </span>
              </span>
              <span class="scope-content-text" v-if="header.sysFlag == '0'">
                {{scope.row[header.prop]}}
              </span>
              <span v-if="header.sysFlag !== '1'&& scope.row.fieldValueObject">
                <span class="scope-content-text">
                  <span v-if="header.unit === '10' && scope.row.fieldValueObject[header.prop]">
                    {{(scope.row.fieldValueObject[header.prop]).substring(0, 10)}}
                  </span>
                  <span v-else>
                    {{scope.row.fieldValueObject[header.prop]}}
                  </span>
                </span>
              </span>
            </div>
            <!-- type = 2 @click.stop="cellClick(header, scope.row, scope.$index)"-->
            <div class="scope-content" style="cursor: pointer;" v-else-if="header.type === '2'">
              <div v-if="header.sysFlag === '1'">
                <el-popover
                  placement="bottom-start"
                  width="140"
                  trigger="hover"
                  ref="popverRef"
                >
                  <div>
                    {{scope.row[header.prop]}}
                  </div>
                  <div class="file_lists" v-if="scope.row.fileList && scope.row.fileList.length > 0">
                    <div class="file_boxs" v-for="(file, index_file) in scope.row.fileList" :key="index_file">
                      <div class="file_text" @click.stop="previewFile(file)">
                        <i class="iconfont icon-wenjian file__icon" />
                        <span class="file_text_name">{{file.fileName}}</span>
                      </div>
                      <!-- <i
                        class="iconfont icon-shanchu1 del__icon"
                        @click="delFunFile(scope.$index, scope.row.fileList, file, index_file)"
                      /> -->
                    </div>
                  </div>
                  <span slot="reference">
                    <span v-if="['', null, undefined].indexOf(scope.row[header.prop]) === -1">
                      <el-tooltip
                        effect="dark"
                        :content="scope.row[header.prop]"
                        placement="top"
                        popper-class="texttooltip"
                        :open-delay="500"
                      >
                        <span class="scope-content-text">
                          <i class="iconfont icon-wenjian file__icon" v-if="scope.row.fileList && scope.row.fileList.length > 0" />
                          {{scope.row[header.prop]}}
                        </span>
                      </el-tooltip>
                    </span>
                    <span v-else-if="scope.row.fileList && scope.row.fileList.length > 0">
                      <i class="iconfont icon-wenjian file__icon" />
                    </span>
                  </span>
                </el-popover>
              </div>
              <div v-else-if="header.sysFlag !== '1' &&scope.row.fieldValueObject&& scope.row.fieldValueObject[header.prop]">
                <el-popover
                  placement="bottom-start"
                  width="140"
                  trigger="hover"
                  ref="popverRef"
                  style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 10px"
                >
                  <div style="padding: 5px 0;">
                    {{scope.row.fieldValueObject[header.prop].content}}
                  </div>
                  <div class="file_lists" v-if="scope.row.fieldValueObject[header.prop].fileList && scope.row.fieldValueObject[header.prop].fileList.length > 0">
                    <div class="file_boxs" v-for="(file, index_file) in scope.row.fieldValueObject[header.prop].fileList" :key="index_file">
                      <div class="file_text" @click.stop="previewFile(file)">
                        <i class="iconfont icon-wenjian file__icon" />
                        <span class="file_text_name">{{file.fileName}}</span>
                      </div>
                      <!-- <i
                        class="iconfont icon-shanchu1 del__icon"
                        @click="delFunFile(scope.$index,scope.row.fieldValueObject[header.prop].fileList, file, index_file)"
                      /> -->
                    </div>
                  </div>
                  <span slot="reference" class="scope-content-text">
                    <span v-if="['', null, undefined].indexOf(scope.row.fieldValueObject[header.prop].content) === -1">
                      <el-tooltip
                        effect="dark"
                        :content="scope.row.fieldValueObject[header.prop].content"
                        placement="top"
                        popper-class="texttooltip"
                        :open-delay="500"
                      >
                        <span>
                          <i class="iconfont icon-wenjian file__icon" v-if="scope.row.fieldValueObject[header.prop].fileList && scope.row.fieldValueObject[header.prop].fileList.length > 0" />
                          {{scope.row.fieldValueObject[header.prop].content}}
                        </span>
                      </el-tooltip>
                    </span>
                    <span v-else>
                      <i class="iconfont icon-wenjian file__icon" />
                    </span>
                  </span>
                </el-popover>
              </div>
            </div>
            <!-- type = 3 @click.stop="cellClick(header, scope.row, scope.$index)"-->
            <div class="scope-content" style="cursor: pointer;" v-else-if="header.type === '3' && scope.row.fieldValueObject && scope.row.fieldValueObject[header.prop]">
              <el-popover
                placement="bottom-start"
                width="140"
                trigger="hover"
                ref="popverRef"
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 10px"
              >
                <div class="file_lists" v-if="scope.row.fieldValueObject[header.prop] && scope.row.fieldValueObject[header.prop].length > 0">
                  <div class="file_boxs" v-for="(file, index_file) in scope.row.fieldValueObject[header.prop]" :key="index_file">
                    <div class="file_text" @click.stop="previewFile(file)">
                      <i class="iconfont icon-wenjian file__icon" />
                      <span class="file_text_name">{{file.fileName}}</span>
                    </div>
                    <!-- <i
                      class="iconfont icon-shanchu1 del__icon"
                      @click="delFunFile(scope.$index,scope.row.fieldValueObject[header.prop], file, index_file)"
                    /> -->
                  </div>
                </div>
                <span slot="reference" class="scope-content-text">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.fieldValueObject[header.prop].length + '个文件'"
                    placement="top"
                    popper-class="texttooltip"
                    :open-delay="500"
                  >
                    <i class="iconfont icon-wenjian file__icon" v-if="scope.row.fieldValueObject[header.prop] && scope.row.fieldValueObject[header.prop].length > 0" />
                  </el-tooltip>
                </span>
              </el-popover>
            </div>
            <!-- type = 5 -->
            <div class="scope-content" v-else-if="header.type === '5' && scope.row.fieldValueObject && scope.row.fieldValueObject[header.prop]">
              <span class="scope-content-text">{{JSON.parse(scope.row.fieldValueObject[header.prop]).addressName}}</span>
            </div>
            <!-- 单选 type = 6 type = 8 -->
            <div class="scope-content" v-else-if="header.type === '6' || header.type === '8'">
              <div v-for="(I, index3) in header.options" :key="index3">
                <span class="scope-content-text" v-if="scope.row[header.prop] === I.key && header.sysFlag === '1'">{{I.name}}</span>
                <span v-else-if="scope.row.fieldValueObject">
                  <span class="scope-content-text" v-if="scope.row.fieldValueObject[header.prop] === I.key">{{I.value}}</span>
                </span>
              </div>
            </div>
            <!-- 多选 type = 7 type = 9 -->
            <div class="scope-content" v-else-if="(header.type === '7' || header.type === '9') && scope.row.fieldValueObject&& scope.row.fieldValueObject[header.prop]">
              <div v-for="(I, index3) in getSelectList(scope.row.fieldValueObject[header.prop], header.options)" :key="index3">
                <span>{{I.value}}</span>
                <span v-if="index3 !== getSelectList(scope.row.fieldValueObject[header.prop], header.options).length-1">,</span>
              </div>
            </div>
            <!-- type = 19 -->
            <div class="scope-content" v-else-if="header.type === '19'">
              <div v-for="(I, index3) in scope.row[header.prop]" :key="index3" @click.stop="deleteModule(scope.row, scope.$index, I.actionType)" style="margin-right: 10px">
                <el-button style="line-height: 10px !important;">{{I.name}}</el-button>
              </div>
            </div>
            <div v-else class="scope-content-id">
              {{scope.row[header.prop]}}
              <span v-if="header.unit">{{header.unit}}</span>
            </div>
          </template>
        </el-table-column>
      </template>
      <el-table-column prop="totalPurchase" label="" width="50px" fixed="right" v-if="tabType !== 'deta'">
        <template slot="header">
          <el-popover
            ref="popover"
            placement="bottom"
            width="330"
            trigger="hover"
            @show="showPopver"
          >
            <div class="filter-box" v-infinite-scroll="load" infinite-scroll-distance="15" @scroll="handleScroll">
              <div class="filter-box-sub">
                <div class="filter-ones title">
                  已选字段
                  <el-input v-model="filedsValue" placeholder="请输入字段名称" @input="filedsValueChange" suffix-icon="el-icon-search" />
                </div>
                <draggable
                  v-if="checkList"
                  v-model="checkList"
                  @end="taskcheck(checkList)"
                  group="serviceUserList"
                  :options="{ handle: '.form_draggable' }"
                  animation="500"
                >
                  <transition-group style="flex-wrap: wrap;display: inline-block;width: 100%;">
                    <div style="padding-bottom: 10px;" class="mode-dragula projectTabs" v-for="(item2, index2) in checkList" :key="index2">
                      <div class="mode-one" style="cursor: pointer;">
                        <i class="iconfont icon-shangxia form_draggable" style="margin-right: 14px;cursor: pointer;color: rgb(204, 204, 204);" />
                        <span style="flex: 1 1 auto;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                          {{item2.label}}
                        </span>
                        <el-checkbox v-model="item2.checkFlag" true-label="1" false-label="0" :disabled="(item2.prop === 'taskname' || item2.prop === 'proname') ? true : false" @change="editFormData1(item2, index2)" />
                      </div>
                    </div>
                  </transition-group>
                </draggable>
              </div>
              <div class="filter-box-sub">
                <div class="filter-ones title">未选字段</div>
                <div>
                  <div style="padding-bottom: 10px;" class="mode-dragula projectTabs" v-for="(item, index1) in uncheckList" :key="index1">
                    <div class="mode-one" style="cursor: pointer;">
                      <i class="iconfont icon-shangxia" style="margin-right: 14px;cursor: pointer;color: rgb(204, 204, 204);" />
                      <span style="flex: 1 1 auto;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;">
                        {{item.label}}
                      </span>
                      <el-checkbox v-model="item.checkFlag" true-label="1" false-label="0" @change="editFormData(item, index1)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span slot="reference">
              <i
                class="iconfont icon-shezhi-xianxing form_name_icon"
                style="cursor: pointer;font-size: 19px;"
              />
            </span>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 视频预览组件 -->
    <VideoPreview
      :visible.sync="showVideo"
      :url="videoUrl"
      @update:visible="val => console.log('visible 更新为:', val)"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { getTaskList, findTaskMenuList, menuConfigSave, getShowAuthority, findProjectMenuList } from '../../../utils/api/task'
import { delFile, initPreviewAuth } from '../../../utils/api/file'
import preview from 'dingtalk-jsapi/api/biz/cspace/preview' // 预览文件
import { wpsOfficeConfig } from '../../../utils/wpsoffice/wpsOffice'
import { findAllMenu, save, moduleBusinessDel } from '../../../utils/api/module'
import VideoPreview from '../videoPreview/index.vue'
export default {
  name: 'TableList',
  components: { draggable, VideoPreview },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    taskid: {
      type: String,
      default: ''
    },
    // 复选框
    checkbox: Boolean,
    // url地址
    url: {
      type: String,
      default: '',
      require: true
    },
    // 数据类型
    method: {
      type: String,
      default: 'post',
      require: true
    },
    data: {
      type: Object,
      default: () => ({})
    },
    shou: {
      type: Boolean,
      default: true
    },
    tab: {
      type: String,
      default: ''
    },
    // 侧边栏数据
    drawer: {
      type: Object,
      default: () => ({})
    },
    tabType: {
      type: String,
      default: ''
    },
    versionId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
      UserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      sels: [], // 选中的值显示
      check_list: [],
      // 表格配置
      table_config: {
        thead: [],
        tableData: []
      },
      clientHeights: document.documentElement.clientHeight.toExponential,
      // 字段列表
      uncheckList: [],
      checkList: [],
      filedsValue: '',
      page: 1,
      pageSize: 50,
      pageNum: 1,
      showVideo: false,
      videoUrl: ''
    }
  },
  computed: {
    tableHeight() {
      console.log(this.$route, 'this.$route')
      return (this.$route.name === 'Projects' || this.$route.name === 'manhour') ? 'calc(100vh - 271px)' : 'calc(100vh - 231px)'
    }
  },
  // 监听config是否有东西进来
  watch: {
    shou: {
      handler() {
        this.table_config.tableData = this.config.tableData
      }
    },
    taskid: {
      handler() {
        this.taskId = this.taskid
      }
    },
    config: {
      handler(newValue) {
        if (this.$route.name === 'ProjectsTask') {
          this.table_config.thead = newValue.theads
        }
        this.$forceUpdate()
        this.$nextTick(() => {
          this.table_config.thead = newValue.theads
          this.$forceUpdate()
        })
      },
      deep: true,
      // 初始化监听
      immediate: true
    }
  },
  created() {
    this.table_config = this.config
    this.taskId = this.taskid
  },
  mounted() {
    console.log(this.$route, 'kkkk')
    this.$nextTick(() => {
      document.addEventListener('click', this.handleClickOutside)
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    getRowKeys(row) {
      return `${row.id}_${row.taskname}`
    },
    handleClickOutside(event) {
      if (this.$refs.popover && this.$refs.popover.$el) {
        const popoverElement = this.$refs.popover.$el
        if (!popoverElement.contains(event.target)) {
          this.$refs.popover.doClose()
        }
      }
    },
    getSelectList(item, list) {
      const keysToMatch = item.split(',')

      // 遍历数组 b 查找匹配的 key 并获取对应的 value
      var result = []
      keysToMatch.forEach(key => {
        const matchedItem = list.find(item => item.key === key)
        if (matchedItem) {
          result.push(matchedItem)
        }
      })
      return result
    },
    // 出入库删除
    deleteModule(row, index, actionType) {
      if (actionType === 'delete') {
        this.$confirm('是否删除该数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          moduleBusinessDel({ id: row.id }).then((data) => {
            if (data.code === 10000) {
              this.table_config.tableData.splice(index, 1)
            } else {
              this.$message.warning(data.info)
            }
          }).catch((error) => {
            console.log(error)
          })
        }).catch(() => {
        // this.$message.info('已取消删除')
        })
      } else {
        if (this.config.rowFun) {
          this.config.rowFun(row, actionType, '2')
        }
      }
    },
    // 获取字段
    showPopver() {
      this.page = 1
      // this.$refs.popover.doShow()
      this.filedsValue = ''
      var page = this.page
      var pageSize = this.pageSize
      var versionId = ''
      if (this.tabType === '2') {
        versionId = this.$parent.$parent.versionId
      } else {
        versionId = ''
      }
      if (this.tabType === '4') {
        var date1 = {
          objectId: '',
          type: this.tabType
        }
        findProjectMenuList(page, pageSize, date1).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = data.result.uncheckPageList.list.filter(item =>
              !(item.listFlag !== '1')
            )
            this.checkList = data.result.checkList?.filter(item =>
              !(item.listFlag !== '1')
            )
            this.pageNum = data.result.uncheckPageList.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabType === '5') {
        var date2 = {
          moduleId: this.table_config.moduleId,
          formId: this.table_config.formId,
          type: '1'
        }
        findAllMenu(date2).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = data.result.uncheckList.filter(item =>
              !(item.listFlag !== '1')
            )
            this.checkList = data.result.checkList?.filter(item =>
              !(item.listFlag !== '1')
            )
            this.pageNum = data.result.uncheckList?.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        var date = {
          objectId: this.$route.query.id,
          type: this.tabType,
          versionId: versionId
        }
        findTaskMenuList(page, pageSize, date).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = data.result.uncheckPageList.list.filter(item =>
              !(item.listFlag !== '1')
            )
            this.checkList = data.result.checkList?.filter(item =>
              !(item.listFlag !== '1')
            )
            this.pageNum = data.result.uncheckPageList.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    load() {
      // if (this.pageNum > this.page) {
      //   this.page += 1
      //   this.showPopver()
      // }
    },
    handleScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target
      // 判断是否滚动到底部
      const isBottom = scrollTop + clientHeight >= scrollHeight
      if (isBottom) {
        // 滚动条到达底部时的逻辑处理
        console.log('滚动条到达底部')
        this.page += 1
        this.showPopver1()
      }
    },
    showPopver1(e) {
      // this.$refs.popover.doShow()
      // this.filedsValue = ''
      var page = this.page
      var pageSize = this.pageSize
      var versionId = ''
      if (this.tabType === '2') {
        versionId = this.$parent.$parent.versionId
      } else {
        versionId = ''
      }
      if (this.tabType === '4') {
        var date1 = {
          objectId: '',
          type: this.tabType,
          searchName: this.filedsValue,
          versionId: versionId
        }
        findProjectMenuList(page, pageSize, date1).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = [...this.uncheckList, ...data.result.uncheckPageList.list.filter(item =>
              !(item.listFlag !== '1')
            )]
            this.pageNum = data.result.uncheckPageList.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabType === '5') {
        console.log(8)
      } else {
        var date = {
          objectId: this.$route.query.id,
          type: this.tabType,
          searchName: this.filedsValue,
          versionId: versionId
        }
        findTaskMenuList(page, pageSize, date).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = [...this.uncheckList, ...data.result.uncheckPageList.list.filter(item =>
              !(item.listFlag !== '1')
            )]
            this.pageNum = data.result.uncheckPageList.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 搜索字段
    filedsValueChange() {
      this.page = 1
      var page = this.page
      var pageSize = this.pageSize
      var versionId = ''
      if (this.tabType === '2') {
        versionId = this.$parent.$parent.versionId
      } else {
        versionId = ''
      }
      if (this.tabType === '4') {
        var date1 = {
          objectId: '',
          type: this.tabType,
          searchName: this.filedsValue
        }
        findProjectMenuList(page, pageSize, date1).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = data.result.uncheckPageList.list.filter(item =>
              !(item.listFlag !== '1')
            )
            this.checkList = data.result.checkList?.filter(item =>
              !(item.listFlag !== '1')
            )
            this.pageNum = data.result.uncheckPageList.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabType === '5') {
        var date2 = {
          moduleId: this.table_config.moduleId,
          formId: this.table_config.formId,
          type: '1'
        }
        findAllMenu(date2).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = data.result.uncheckList.filter(item =>
              !(item.listFlag !== '1')
            )
            this.checkList = data.result.checkList?.filter(item =>
              !(item.listFlag !== '1')
            )
            this.pageNum = data.result.uncheckList?.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        var date = {
          objectId: this.$route.query.id,
          type: this.tabType,
          searchName: this.filedsValue,
          versionId: versionId
        }
        findTaskMenuList(page, pageSize, date).then((data) => {
          if (data.code === 10000) {
            this.uncheckList = data.result.uncheckPageList.list.filter(item =>
              !(item.listFlag !== '1')
            )
            this.checkList = data.result.checkList?.filter(item =>
              !(item.listFlag !== '1')
            )
            this.pageNum = data.result.uncheckPageList.pages
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 选择字段
    editFormData(item, index) {
      item.checkFlag = '1'
      this.uncheckList.splice(index, 1)
      this.checkList.push(item)
      this.menuConfigSave(this.checkList)
    },
    editFormData1(item, index) {
      item.checkFlag = '0'
      this.checkList.splice(index, 1)
      this.uncheckList.unshift(item)
      this.menuConfigSave(this.checkList)
    },
    menuConfigSave(list) {
      if (this.tabType === '5') {
        var date1 = {
          moduleId: this.table_config.moduleId,
          formId: this.table_config.formId,
          type: '1',
          content: JSON.stringify(list)
        }
        save(date1).then((data) => {
          if (data.code === 10000) {
            this.$parent.getMenuConfig()
          } else {
            this.$message.error(data.message)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        var versionId = ''
        if (this.tabType === '2') {
          versionId = this.$parent.$parent.versionId
        } else {
          versionId = ''
        }
        var date = {
          objectId: this.$route.query.id,
          type: this.tabType,
          scope: '',
          menuConfig: JSON.stringify(list),
          versionId: versionId
        }
        menuConfigSave(date).then((data) => {
          if (data.code === 10000) {
            if (this.tabType === '3') {
            // this.$parent.findTodoPageList()
              this.$parent.$parent.getTaskList()
              this.$parent.$parent.getMenuConfig('3')
            } else if (this.tabType === '1') {
              this.$parent.$parent.getMenuConfig('1')
              this.$parent.$parent.getTaskList()
            } else if (this.tabType === '2') {
              this.$parent.$parent.getMenuConfig()
              this.$parent.$parent.getTaskLists()
            } else if (this.tabType === '4') {
              this.$parent.getMenuConfig()
              this.$parent.getList()
            }
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 未选字段排序
    taskFollow(list) {
      list.map((item, index) => {
        item.sort = index
      })
      console.log(list)
    },
    // 已选字段排序
    taskcheck(list) {
      list.map((item, index) => {
        item.sort = index
      })
      this.menuConfigSave(list)
    },
    // 标签透明度
    convertHex(hex, opacity) {
      hex = hex?.replace('#', '')
      var r = parseInt(hex?.substring(0, 2), 16)
      var g = parseInt(hex?.substring(2, 4), 16)
      var b = parseInt(hex?.substring(4, 6), 16)
      var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
      return result
    },
    // 单元格点击方法
    cellClick(row, column, cell, event) {
      console.log(row, column, cell, event, 'row, column, cell, event')
    },
    handleCellClick(row, header) {
      if (this.config.handleCellClick) {
        this.config.handleCellClick(row, header)
      }
    },
    // 删除文件
    delFunFile(index1, list, file, index) {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var date = {
          id: file.id
        }
        delFile(date).then((data) => {
          if (data.code === 10000) {
            list.splice(index, 1)
            this.$forceUpdate() // 强制更新视图
          }
        }).catch(() => {
        })
      }).catch(() => {
      })
    },
    // 预览文件
    previewFile(item) {
      var date1 = {
        fileId: item.id
      }
      getShowAuthority(date1).then((data1) => {
        if (data1.code === 10000) {
          var date = {
            fileIds: item.dingFileId
          }
          if (item?.source === 'ding') {
            initPreviewAuth(date).then((data) => {
              if (data.code === 10000) {
                preview({
                  corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
                  spaceId: item.dingSpaceId,
                  fileId: item.dingFileId,
                  fileName: item.fileName,
                  fileSize: item.fileSize,
                  fileType: item.fileFormat,
                  onSuccess: function(res) {
                    console.log(res, '')
                  },
                  onFail: function(err) {
                    console.log(err)
                  // alert('数据 ' + JSON.stringify(err))
                  }
                })
              }
            }).catch((error) => {
              console.log(error)
            //  this.$message.error('网络错误，请稍候！')
            })
          } else {
            var imgs = ['MP4', 'AVI', 'WMV', 'MKV', 'FLV', 'MPG', 'MPEG', 'M2V', 'M3U8', 'TS', 'MOV', 'WMV', 'RM', 'RMVB', 'ASF', 'VOB', 'DAT', 'DV', 'M4V', 'WEBM', 'OGG', '3GP', 'MPEG4',
              'mp4', 'avi', 'wmv', 'mkv', 'flv', 'mpg', 'mpeg', 'm2v', 'm3u8', 'ts', 'mov', 'wmv', 'rm', 'rmvb', 'asf', 'vob', 'dat', 'dv', 'm4v', 'webm', 'ogg', '3gp', 'mpeg'
            ]
            if (imgs.includes(item.fileFormat)) {
              this.showVideo = true
              this.videoUrl = item.absoUrl
            } else {
              wpsOfficeConfig(item)
            }
          }
        } else {
          this.$message.warning(data1.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 选择
    changeBox(sels) {
      this.sels = sels
      this.$emit('func', this.sels)
    },
    // 拉取子任务数据
    loadChiTask(tree, treeNode, resolve) {
      var page = 1
      var pageSize = 100
      var date = {
        proTypeFlag: '1',
        parentId: tree.id
      }
      // 子任务列表
      getTaskList(page, pageSize, date).then((data) => {
        if (data.code === 10000) {
          var list = data.result.list
          resolve(list)
        }
      }).catch(() => {})
    },
    /**
     * 复选框
     */
    handleSelectionChange(val) {
    },
    initConfig() {
      // 初始化配置
      for (const key in this.config) {
        // 判断keys 是不是存在  存在时替换
        if (Object.keys(this.table_config).includes(key)) {
          this.table_config[key] = this.config[key]
        }
      }
    },
    // 数据加载
    loadList() {
      // this.table_config.tableData = this.table_config.tableData.concat(this.table_config.tableData)
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 点击表格整行
    rowFun(row) {
      console.log(row, 'row')
      console.log(this.table_config.tableData.length, '列表数据')
      if (this.config.rowFun) {
        this.config.rowFun(row, '')
        localStorage.setItem('RowIndex', JSON.stringify(row.index))
        localStorage.setItem('Rowvalue', JSON.stringify(row))
      }
    },
    // 表格列拖动
    headerDragend(newWidth, oldWidth, column, event) {
      this.table_config.theads.map((item) => {
        if (item.prop === column.property) {
          item.width = newWidth
        }
      })
      if (this.tabType === '5') {
        var date1 = {
          moduleId: this.table_config.moduleId,
          formId: this.table_config.formId,
          type: '1',
          content: JSON.stringify(this.table_config.theads)
        }
        save(date1).then((data) => {
          if (data.code === 10000) {
            this.$parent.getMenuConfig()
          } else {
            this.$message.error(data.message)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        var versionId = ''
        if (this.tabType === '2') {
          versionId = this.$parent.$parent.versionId
        } else {
          versionId = ''
        }
        var date = {
          objectId: this.$route.query.id,
          type: this.tabType,
          scope: '',
          menuConfig: JSON.stringify(this.table_config.theads),
          versionId: versionId
        }
        menuConfigSave(date).then((data) => {
          if (data.code === 10000) {
            console.log(1)
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/index.scss';
::v-deep .el-table .cell {
  display: flex;
  align-items: center;
  height: 38px;
  line-height: 38px !important;
}
::v-deep .el-table__body-wrapper {
  // height: calc(100% - 50px)!important;
  // z-index: 99;
  // overflow: auto;
}
::v-deep .el-table .el-table__expand-icon {
  margin-left: -16px;
}
.scope-content-id {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
::v-deep .el-table [class*='el-table__row--level'] .el-table__expand-icon {
  margin-right: 0px;
}
::v-deep .tableTextColor{
  font-size: $font_12;
  border-radius: 4px;
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
}
::v-deep .tableTextColor8 {
  line-height: 20px;
  padding: 2px 8px;
  display: inline-block;
  margin: auto;
  color: #fa7068;
}
// 未指派
.tableTextColor1 {
  color: #f1ad38;
  background: rgba(241, 173, 56, 0.1);
}
// 未完成
.tableTextColor2 {
  color: #74bf7a;
  background: rgba(116, 191, 122, 0.1);
}
// 待测试
.tableTextColor3 {
  color: #ff9c95;
  background: rgba(255, 156, 149, 0.1);
}
// 测试中
.tableTextColor4 {
  color: #fa7068;
  background: rgba(250, 112, 104, 0.1);
}
// 待确认
.tableTextColor5 {
  color: #8fb9ff;
  background: rgba(143, 185, 255, 0.1);
}
// 已完成
.tableTextColor6 {
  color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
// 已终止
.tableTextColor7{
  color: #a8a8a8;
  background: rgba(168, 168, 168, 0.1);
}
.scpc-task-table {
  .scpc-operate-photos {
    // width: 30px;

    min-width: 30px;
    max-width: 50px;
    // border-radius: 50%;
    overflow: hidden;
  }
  .scope-content {
    width: 100%;
    display: flex;
    align-items: center;
    .scope-content-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
    }
    .scpc-operate-icon {
      flex: none;
    }
    .scpc-operate-icon:hover.liuchen_icon {
      display: inline-block;
    }
    .scpc-operate-photo {
        .img {
        width: 27px;
        height: 27px;
        font-size: $font_14;
        font-family: $font_family1;
        font-weight: 400;
        color: $color_white;
        line-height: 27px;
        text-align: center;
        background: $color_main;
        border-radius: 50%;
        margin-right: 10px;
      }
      div {
        img {
          width: 27px;
          height: 27px;
          border-radius: 50%;
          margin-right: 10px;
          vertical-align: middle;
        }
      }
    }
  }
}
.task_within {
  font-weight: 400;
  font-size: $font_12;
  padding: 1px 1px 0 1px;
  line-height: 14px;
  border-radius: 3px;
  color: #dd483f;
  background: $color_white;
  border: 1px solid #dd483f;
  margin-right: 10px;
}
::v-deep .el-table thead .el-table__cell {
  padding: 0 !important;
}
::v-deep.el-table__row:not([class*='el-table__row--level-']) {
  td:nth-child(2) {
    padding-left: 24px !important;
  }
}
::v-deep .el-table__placeholder{
margin-left: -15px !important;
}

.ps{
  height: 100%;
}
// 自定义字段选择
.filter-box{
  max-height: 600px;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 10px 0;
}
.filter-box-sub{
  border-bottom: 1px solid #eee;
  padding: 0 16px;
}
.filter-ones{
  padding: 0 4px;
    height: 30px;
    line-height: 30px;
    margin: 4px 0;
    box-sizing: border-box;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    .title{
    color: #999;
    cursor: default;
}
}
::v-deep .el-input {
    width: 185px;
    .el-input__inner{
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon{
      line-height: 36px;
  }
}
.projectTabs {
    min-width: 80px!important;
    .mode-one{
      line-height: 30px;
    cursor: pointer;
    padding: 0 5px;
    border-radius: 4px;
    transition: all .2s ease;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    // justify-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    ::v-deep .el-checkbox {
    // display: flex !important;
    // align-items: center !important;
    .el-checkbox__input {
      // position: fixed !important;
      // right: 25px !important;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
          background-color: #F2F6FC !important;
          border-color: #DCDFE6 !important;
      }
    }
    }
}
.form_draggable {
    font-size: $font_16;
    color: $color_main;
    // margin-right: 6px;
    line-height: 34px;
  }
  ::v-deep .el-table__fixed-right {
    box-shadow: none !important;
  }
  .file_lists {
  width: 100%;
  padding-bottom: 5px;
  font-size: $font_12;
  font-family: $font_family;
  font-weight: 400;
  color: #909090;
  line-height: 24px;
  .file_boxs {
    width: calc(100% - 10px);
    // padding: 0 5px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .file_boxs:hover{
    // background: rgba(40, 120, 255, 0.1);
  }
  .file_text{
    display: flex;
    align-items: center;
  }
  .file_text_name{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    margin-right: 10px;
    width: 90px;
    padding: 0 2px;
    &:hover{
      background: rgba(40, 120, 255, 0.1);
    }
  }
}
.file__icon {
  font-size: $font_14;
  color: #ffb83e;
  margin-right: 5px;
}
.del__icon{
  display: none;
}
.file_boxs:hover .del__icon{
    display: block;
  }
</style>
<style>
.el-progress-bar__outer {
  height: 12px !important;
  background: rgba(40, 120, 255, 0.1) !important;
  border-radius: 2px!important;;
}
.el-progress-bar__inner {
  background: #2868ff;
  border-radius: 2px;
}
.el-progress__text {
  color:#2868ff;
  margin-left: 12px;
  font-size: 14px !important;
}

.el-table--border .el-table__cell{
  border-right: none !important;
}
.el-table__header .el-table__cell{
  border-right: 1px solid #EBEEF5 !important;
}
.el-table__empty-block{
  /* display: none !important; */
}
</style>

